module.exports = __webpack_public_path__ + "media/site_templates/www.tv-installation.com.au/images/splash-f295bd7f652e3b88894798bd60de6e77.jpg";